import React, { useState } from 'react';
import Modal from 'antd/lib/modal/Modal';
import { Button, message, Row, Input, Col } from 'antd';
import { observer } from 'mobx-react';
import { isEmpty } from 'lodash';
import FormItem from '../../../components/FormItem';

export interface IAddSourceDialogProps {
  isOpen: boolean;
  onAdd: (sourceTitle: string) => void;
  onClose: () => void;
}

export const AddSourceDialog: React.FC<IAddSourceDialogProps> = observer(({ isOpen, onAdd, onClose }) => {
  const [sourceTitle, setSourceTitle] = useState('');

  const handleAdd = () => {
    if (isEmpty(sourceTitle)) {
      message.warning('Не задано имя источника', 3);
      return;
    }

    onAdd(sourceTitle);
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div>
      <Modal
        visible={isOpen}
        title="Добавление источника"
        onCancel={handleCancel}
        footer={[
          <Button key="apply" onClick={handleAdd} type="primary">
            Добавить
          </Button>,
          <Button key="cancel" onClick={handleCancel}>
            Закрыть
          </Button>,
        ]}
      >
        <Row>
          <Col span={24}>
            <FormItem label="Имя источника">
              <Input
                style={{ width: '100%' }}
                placeholder=""
                value={sourceTitle}
                onChange={(e) => setSourceTitle(e.target.value)}
              />
            </FormItem>
          </Col>
        </Row>
      </Modal>
    </div>
  );
});
